import clsx from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import Label from './Label';

export type FormFieldProps = {
  children: ReactNode;
  label?: string;
  hint?: string;
  error?: string;
  id?: string;
  disabled?: boolean;
  className?: string;
};

const FormField = ({ children, label, hint, error, id, disabled, className }: FormFieldProps) => {
  return (
    <div className={twMerge(clsx('flex flex-col', className))}>
      {label && (
        <Label htmlFor={id} disabled={disabled}>
          {label}
        </Label>
      )}
      {children}
      {(error || hint) && (
        <span
          className={clsx(
            'mt-1.5 typography-body-sm',
            error ? 'text-accent-tomato-500' : 'text-accent-selective-yellow-500',
          )}
        >
          {error || hint}
        </span>
      )}
    </div>
  );
};

export default FormField;
